// Shared constants and static data for the Waltech site
export const WHATSAPP_NUMBER = "5511957303668";

export const buildWhatsAppLink = (message) =>
  `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;

export const CONTACT = {
  phone1: "(11) 95730-3668",
  phone2: "(11) 2391-0229",
  email: "comercial@waltech.com.br",
  addressLine1: "Rua Verbo Divino, 2001",
  addressLine2: "Chácara Santo Antônio",
  addressLine3: "São Paulo / SP",
};

export const SOCIALS = {
  facebook: "https://www.facebook.com/",
  instagram: "https://www.instagram.com/jefdavy",
  linkedin: "https://www.linkedin.com/in/jeferson-oliveira-bb9363236",
  whatsapp: buildWhatsAppLink("Olá! Gostaria de falar com a Waltech."),
};

export const CLIENT_AREA_URL = "https://waltech.solvedesk.com.br/";

export const CLIENTS = [
  { name: "Adw Soluções em Informática", logo: process.env.PUBLIC_URL + "/images/clients/adw.png" },
  { name: "BR2T", logo: process.env.PUBLIC_URL + "/images/clients/br2t.png" },
  { name: "Exatronic", logo: process.env.PUBLIC_URL + "/images/clients/exatronic.jpg" },
  { name: "D4D", logo: process.env.PUBLIC_URL + "/images/clients/d4d.png" },
  { name: "Á Obra Construções", logo: process.env.PUBLIC_URL + "/images/clients/aobra.jpg" },
  { name: "Supermercado Panorama", logo: process.env.PUBLIC_URL + "/images/clients/panorama.png" },
];

// Service icon keys map to lucide-react icons inside the Services component
export const SERVICE_KEYS = [
  "support",
  "security",
  "infra",
  "backup",
  "licensing",
  "projects",
];
